/**
 * Top part of header, shows completed items and there price,
 * allows to deleting and editing items.
 */
import { LitElement, css, customElement, html } from 'lit-element';
import {
  B_FLOW_ID,
  C_B_FLOW_ID,
  C_FLOW_ID,
  C_PL_FLOW_ID,
  PL_B_FLOW_ID,
  PL_FLOW_ID,
  TRIPLE_FLOW_ID,
} from '../boilerplate/item-ids';
import { B_ITEM, C_ITEM, PL_ITEM } from '../boilerplate/item-names';
import getItemName from '../utils/get-item-name';

/**
 * LitElement
 * A simple base class for creating fast, lightweight web components.
 *
 * @docs https://lit-element.polymer-project.org/
 */
@customElement('shopping-cart')
class ShoppingCartComponent extends LitElement {
  static get properties() {
    return {
      isOpened: { type: Boolean },
      items: { type: Array },
      end_screen: { type: Object },
    };
  }

  constructor() {
    super();
    this.isOpened = false;
    this.items = [];
    this.end_screen = '';
    this.itemA = C_FLOW_ID;
    this.itemB = PL_FLOW_ID;
    this.itemC = B_FLOW_ID;
    this.itemAB = C_PL_FLOW_ID;
    this.itemAC = C_B_FLOW_ID;
    this.itemBC = PL_B_FLOW_ID;
    this.stateChangeEvent = (kasko) => this.stateChanged(kasko);
  }

  static get styles() {
    return css`
      .shopping-cart-block {
        position: relative;
        cursor: pointer;
        display: flex;
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='44px' height='36px' viewBox='0 0 44 36' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EIcon-big/Angebot Copy 12%3C/title%3E%3Cdefs%3E%3Crect id='path-1' x='0' y='0' width='52' height='52'%3E%3C/rect%3E%3Cfilter id='filter-3'%3E%3CfeColorMatrix in='SourceGraphic' type='matrix' values='0 0 0 0 0.470588 0 0 0 0 0.466667 0 0 0 0 0.447059 0 0 0 1.000000 0'%3E%3C/feColorMatrix%3E%3C/filter%3E%3C/defs%3E%3Cg id='Style-Guide' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='04-Visana-Style-Guide-Icons+Logo' transform='translate(-398.000000, -373.000000)'%3E%3Cg id='Icon-big/Angebot-Copy-12' transform='translate(396.000000, 365.000000)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cg id='Background'%3E%3C/g%3E%3Cg filter='url(%23filter-3)' id='icons8-sell_stock'%3E%3Cg mask='url(%23mask-2)'%3E%3Cg transform='translate(2.000000, 8.000000)' fill='%23000000' fill-rule='nonzero' id='Shape'%3E%3Cpath d='M1.52136373,0.000144843258 C0.980409859,-0.00735494329 0.477241687,0.276858435 0.204532152,0.744104766 C-0.0681773838,1.2113511 -0.0681773838,1.78923989 0.204532152,2.25648622 C0.477241687,2.72373255 0.980409859,3.00794593 1.52136373,3.00029549 L4.27722313,3.00029549 C5.00515603,3.00029549 5.61195023,3.50321979 5.74987933,4.21904549 L6.04870753,5.78154549 L9.27331673,22.7170925 C9.85643173,25.7726165 12.5484987,28.0002955 15.6600357,28.0002955 L34.3826917,28.0002955 C37.4942287,28.0002955 40.1874277,25.7734725 40.7694107,22.7170925 L43.9940197,5.78154549 C44.0777673,5.34252564 43.961403,4.88902694 43.6766209,4.54456901 C43.3918389,4.20011108 42.9683,4.00057023 42.5213637,4.00029549 L8.76159773,4.00029549 L8.69714473,3.65849859 C8.29402073,1.54582759 6.42833423,0.000144843258 4.27722313,0.000144843258 L1.52136373,0.000144843258 Z M9.33386373,7.00029549 L40.7088637,7.00029549 L37.8221447,22.1565455 C37.5061277,23.8161655 36.0731547,25.0002955 34.3826917,25.0002955 L15.6600357,25.0002955 C13.9701717,25.0002955 12.5381447,23.8160955 12.2205827,22.1565455 L12.2205827,22.1545925 L9.33386373,7.00029549 Z M21.5213637,10.0002955 C20.9804099,9.99264506 20.4772417,10.2768584 20.2045322,10.7441048 C19.9318226,11.2113511 19.9318226,11.7892399 20.2045322,12.2564862 C20.4772417,12.7237325 20.9804099,13.0079459 21.5213637,13.0002955 L29.5213637,13.0002955 C30.0623176,13.0079459 30.5654858,12.7237325 30.8381953,12.2564862 C31.1109049,11.7892399 31.1109049,11.2113511 30.8381953,10.7441048 C30.5654858,10.2768584 30.0623176,9.99264506 29.5213637,10.0002955 L21.5213637,10.0002955 Z M18.0213637,30.0002955 C16.3645095,30.0002955 15.0213637,31.3434412 15.0213637,33.0002955 C15.0213637,34.6571497 16.3645095,36.0002955 18.0213637,36.0002955 C19.678218,36.0002955 21.0213637,34.6571497 21.0213637,33.0002955 C21.0213637,31.3434412 19.678218,30.0002955 18.0213637,30.0002955 Z M32.0213637,30.0002955 C30.3645095,30.0002955 29.0213637,31.3434412 29.0213637,33.0002955 C29.0213637,34.6571497 30.3645095,36.0002955 32.0213637,36.0002955 C33.678218,36.0002955 35.0213637,34.6571497 35.0213637,33.0002955 C35.0213637,31.3434412 33.678218,30.0002955 32.0213637,30.0002955 Z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: contain;
        width: 40px;
        height: 40px;
      }

      [active].shopping-cart-block {
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='44px' height='36px' viewBox='0 0 44 36' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EIcon-big/Angebot Copy 12%3C/title%3E%3Cdefs%3E%3Crect id='path-1' x='0' y='0' width='52' height='52'%3E%3C/rect%3E%3Cfilter id='filter-3'%3E%3CfeColorMatrix in='SourceGraphic' type='matrix' values='0 0 0 0 0.470588 0 0 0 0 0.466667 0 0 0 0 0.447059 0 0 0 1.000000 0'%3E%3C/feColorMatrix%3E%3C/filter%3E%3C/defs%3E%3Cg id='Style-Guide' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='04-Visana-Style-Guide-Icons+Logo' transform='translate(-398.000000, -373.000000)'%3E%3Cg id='Icon-big/Angebot-Copy-12' transform='translate(396.000000, 365.000000)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cg id='Background'%3E%3C/g%3E%3Cg id='icons8-sell_stock'%3E%3Cg mask='url(%23mask-2)'%3E%3Cg transform='translate(2.000000, 8.000000)' fill='%23000000' fill-rule='nonzero' id='Shape'%3E%3Cpath d='M1.52136373,0.000144843258 C0.980409859,-0.00735494329 0.477241687,0.276858435 0.204532152,0.744104766 C-0.0681773838,1.2113511 -0.0681773838,1.78923989 0.204532152,2.25648622 C0.477241687,2.72373255 0.980409859,3.00794593 1.52136373,3.00029549 L4.27722313,3.00029549 C5.00515603,3.00029549 5.61195023,3.50321979 5.74987933,4.21904549 L6.04870753,5.78154549 L9.27331673,22.7170925 C9.85643173,25.7726165 12.5484987,28.0002955 15.6600357,28.0002955 L34.3826917,28.0002955 C37.4942287,28.0002955 40.1874277,25.7734725 40.7694107,22.7170925 L43.9940197,5.78154549 C44.0777673,5.34252564 43.961403,4.88902694 43.6766209,4.54456901 C43.3918389,4.20011108 42.9683,4.00057023 42.5213637,4.00029549 L8.76159773,4.00029549 L8.69714473,3.65849859 C8.29402073,1.54582759 6.42833423,0.000144843258 4.27722313,0.000144843258 L1.52136373,0.000144843258 Z M9.33386373,7.00029549 L40.7088637,7.00029549 L37.8221447,22.1565455 C37.5061277,23.8161655 36.0731547,25.0002955 34.3826917,25.0002955 L15.6600357,25.0002955 C13.9701717,25.0002955 12.5381447,23.8160955 12.2205827,22.1565455 L12.2205827,22.1545925 L9.33386373,7.00029549 Z M21.5213637,10.0002955 C20.9804099,9.99264506 20.4772417,10.2768584 20.2045322,10.7441048 C19.9318226,11.2113511 19.9318226,11.7892399 20.2045322,12.2564862 C20.4772417,12.7237325 20.9804099,13.0079459 21.5213637,13.0002955 L29.5213637,13.0002955 C30.0623176,13.0079459 30.5654858,12.7237325 30.8381953,12.2564862 C31.1109049,11.7892399 31.1109049,11.2113511 30.8381953,10.7441048 C30.5654858,10.2768584 30.0623176,9.99264506 29.5213637,10.0002955 L21.5213637,10.0002955 Z M18.0213637,30.0002955 C16.3645095,30.0002955 15.0213637,31.3434412 15.0213637,33.0002955 C15.0213637,34.6571497 16.3645095,36.0002955 18.0213637,36.0002955 C19.678218,36.0002955 21.0213637,34.6571497 21.0213637,33.0002955 C21.0213637,31.3434412 19.678218,30.0002955 18.0213637,30.0002955 Z M32.0213637,30.0002955 C30.3645095,30.0002955 29.0213637,31.3434412 29.0213637,33.0002955 C29.0213637,34.6571497 30.3645095,36.0002955 32.0213637,36.0002955 C33.678218,36.0002955 35.0213637,34.6571497 35.0213637,33.0002955 C35.0213637,31.3434412 33.678218,30.0002955 32.0213637,30.0002955 Z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }

      .items-amount {
        position: absolute;
        background: #e30613;
        color: #fff;
        font-size: 13px;
        border-radius: 50%;
        height: 18px;
        width: 18px;
        display: flex;
        align-items: baseline;
        justify-content: center;
        top: -3px;
        right: -7px;
      }

      .shopping-cart-modal {
        max-width: 354px;
        width: 354px;
        position: absolute;
        right: 0;
        top: 58px;
        background: #fff;
        padding: 19px 0;
        border: 1px solid #efe6dc;
        -webkit-box-shadow: -2px 2px 8px 0px rgba(239, 230, 220, 0.75);
        -moz-box-shadow: -2px 2px 8px 0px rgba(239, 230, 220, 0.75);
        box-shadow: -2px 2px 8px 0px rgba(239, 230, 220, 0.75);
      }

      .shopping-cart-title {
        font-size: 26px;
        color: #000;
        padding: 0 13px;
      }

      .shopping-cart-note {
        margin-top: 25px;
        font-size: 13px;
        color: #787772;
        display: flex;
        padding: 0 13px;
      }

      .shopping-cart-note .item-name {
        width: 66%;
      }

      .item-container {
        display: flex;
        border-top: 1px solid #efe6dc;
        border-bottom: 1px solid #efe6dc;
        padding: 0 0 0 13px;
        font-size: 13px;
        align-items: center;
      }

      .item-container .blue {
        color: #433894;
        font-size: 15px;
      }

      .item-container .orange {
        color: #fb8900;
        font-size: 15px;
      }

      .item-container .red {
        color: #f05d23;
        font-size: 15px;
      }

      .item-container div {
        padding: 19px 0;
      }

      .item-cost {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        text-align: center;
        padding: 0 !important;
      }

      .edit-button {
        border-left: 1px solid #efe6dc;
        border-right: 1px solid #efe6dc;
      }

      .edit-button,
      .remove-button {
        text-align: center;
        cursor: pointer;
      }

      .shopping-cart-total {
        display: flex;
        border-bottom: 1px solid #efe6dc;
        padding: 19px 13px;
        align-items: center;
        font-size: 15px;
        color: #000;
      }

      .shopping-cart-total div:first-child {
        width: 77%;
      }

      .shopping-cart-modal .item-container > span:first-child {
        width: 57%;
      }

      .shopping-cart-modal .item-container .remove-button,
      .shopping-cart-modal .item-container .edit-button {
        width: 12%;
      }

      .shopping-cart-button {
        display: flex;
        justify-content: flex-end;
        margin-top: 18px;
        font-size: 13px;
      }

      .shopping-cart-button div {
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='20px' height='20px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EIcon-small/Arrow-right-full%3C/title%3E%3Cg id='Icon-small/Arrow-right-full' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='Bounding-Box' x='0' y='0' width='24' height='24'%3E%3C/rect%3E%3Cpath d='M12,2 C17.5221093,2 22,6.47684328 22,12 C22,17.5221093 17.5221093,22 12,22 C6.47684328,22 2,17.5221093 2,12 C2,6.47684328 6.47684328,2 12,2 Z M17.1821093,9.01368606 L11.99895,14.1968453 L6.817896,9.01368606 L5.68000097,10.1536864 L11.435792,15.91053 L11.99895,16.4494775 L12.5694765,15.9042142 L18.3200043,10.1536864 L17.1821093,9.01368606 Z' id='Combined-Shape' fill='%23E30613' transform='translate(12.000000, 12.000000) rotate(270.000000) translate(-12.000000, -12.000000) '%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px center;
        color: #000;
        padding-right: 40px;
        cursor: pointer;
      }

      @media only screen and (max-width: 576px) {
        .shopping-cart-block {
          width: 25px;
          height: 25px;
        }

        .items-amount {
          right: unset;
        }
      }
    `;
  }

  render() {
    return html`
      <div class="shopping-cart-container">
        <div
          class="shopping-cart-block"
          ?filled="${this.items?.length}"
          ?active="${this.isOpened}"
          @click=${() => this.openCart()}
        >
          ${this.items?.length ? html`<span class="items-amount">${this.items.length}</span>` : ''}
        </div>
        ${
          this.isOpened
            ? html`
              <div class="shopping-cart-modal">
                <div class="shopping-cart-title">
                  ${this.kasko.getTranslation('flow.shopping_cart.title')}
                </div>
                <div class="shopping-cart-note">
                  <div class="item-name">
                    ${this.kasko.getTranslation('flow.shopping_cart.item.title')}
                  </div>
                  <div class="currency">CHF</div>
                </div>
                ${this.items.map(
                  (item) => html`
                    <div class="item-container">
                      <span class="${item.color}"
                        >${this.kasko.getTranslation(item.title)}</span
                      >
                      <div class="item-cost">
                        <span>${this.getCostObject(item.cost).currency}</span>
                        <span>${this.getCostObject(item.cost).price}</span>
                      </div>
                      <div
                        class="edit-button"
                        @click=${() => this.editItem(item.editScreen)}
                      >
                        <?xml version="1.0" encoding="UTF-8"?>
                        <svg
                          width="13px"
                          height="13px"
                          viewBox="0 0 24 24"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <title>Icon-small/Bearbeiten</title>
                          <g
                            id="Icon-small/Bearbeiten"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <rect
                              id="Bounding-Box"
                              x="0"
                              y="0"
                              width="24"
                              height="24"
                            ></rect>
                            <path
                              d="M19.2664461,1 C20.213739,1 21.1623259,1.36752892 21.8960897,2.10258676 C23.3674994,3.57270244 23.3674994,5.89175815 21.8960897,7.36187383 L21.8960897,7.36187383 L7.58834412,21.6709135 L7.30493273,21.7278546 L2.32776293,22.7165591 L1,22.9999705 L1.28211727,21.6709135 L2.27211594,16.6937437 L2.32776293,16.4103323 L16.6368026,2.10258676 C17.3718604,1.36752892 18.3191533,1 19.2664461,1 Z M3.91176081,17.7122129 L3.31905572,20.6809148 L6.28646351,20.0869156 C5.84905233,19.0024465 4.99752406,18.1496241 3.91176081,17.7122129 L3.91176081,17.7122129 Z M16.0143328,5.29775895 L5.07128866,16.2408031 C6.23081652,16.8348023 7.1638741,17.7678599 7.7578733,18.9273877 L7.7578733,18.9273877 L18.7009175,7.98434358 L16.0143328,5.29775895 Z M19.2664461,2.7237624 C18.8109173,2.7237624 18.3515062,2.93340917 17.9089185,3.3747027 L17.9089185,3.3747027 L17.2864488,4.02564301 L19.9743275,6.71222764 L20.6239737,6.08975789 C21.5039725,5.20975907 21.5039725,4.25599564 20.6239737,3.3747027 C20.1826802,2.93340917 19.7219749,2.7237624 19.2664461,2.7237624 Z"
                              id="Combined-Shape"
                              fill="#787772"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div
                        class="remove-button"
                        @click=${() => this.removeItem(item)}
                      >
                        <?xml version="1.0" encoding="UTF-8"?>
                        <svg
                          width="14px"
                          height="14px"
                          viewBox="0 0 24 24"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <title>Icon-small/Close</title>
                          <g
                            id="Icon-small/Close"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <rect
                              id="Bounding-Box"
                              x="0"
                              y="0"
                              width="24"
                              height="24"
                            ></rect>
                            <polygon
                              id="Path"
                              fill="#787772"
                              points="3.21875 1.78125 1.78125 3.21875 10.5625 12 1.78125 20.78125 3.21875 22.21875 12 13.4375 20.78125 22.21875 22.21875 20.78125 13.4375 12 22.21875 3.21875 20.78125 1.78125 12 10.5625"
                            ></polygon>
                          </g>
                        </svg>
                      </div>
                    </div>
                  `,
                )}
                <div class="shopping-cart-total">
                  <div>
                    ${this.kasko.getTranslation('flow.total_sum.title')}
                  </div>
                  <div>
                    ${this.kasko.getTranslation('flow.total_sum.value')}
                  </div>
                </div>
                <div class="shopping-cart-button">
                  <div @click="${() => this.navigateToEnd()}">
                    ${this.kasko.getTranslation('flow.shopping_cart.next_button')}
                  </div>
                </div>
              </div>
            `
            : ''
        }
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.kasko.addEventListener('state-changed', this.stateChangeEvent);
    this.items = this.kasko.getState().input.shopping_cart_items;
  }

  disconnectedCallback() {
    this.kasko.removeEventListener('state-changed', this.stateChangeEvent);
    super.disconnectedCallback();
  }

  openCart() {
    if (this.items?.length && this.kasko.getState('quote').data) {
      this.isOpened = !this.isOpened;

      const background = this.closest('.shopping-basket');

      if (background && this.isOpened) {
        background.classList.add('opened-cart');
      }

      if (background && !this.isOpened) {
        background.classList.remove('opened-cart');
      }
    }
  }

  editItem(screen) {
    this.kasko.dispatchEvent('go-to-screen', { screen });
  }

  removeItem(item) {
    const inputState = this.kasko.getState('input');
    if (
      !inputState.item_A_B &&
      !inputState.item_B_C &&
      !inputState.item_A_C &&
      !inputState.item_A_B_C
    ) {
      return;
    }
    if (inputState.item_id === TRIPLE_FLOW_ID && inputState.shopping_cart_items.length < 3) {
      return;
    }
    if (inputState.shopping_cart_items.length < 2) {
      return;
    }
    const background = this.closest('.shopping-basket');
    if (background) {
      background.classList.remove('opened-cart');
    }
    const requestItemId = this.getRequestItemId(item);
    const { language } = inputState;
    if (item.editScreen === 'summary') {
      this.kasko.dispatchEvent('set-state-input', {
        deleted_item_label: getItemName(C_ITEM, language),
      });
    } else if (item.editScreen === 'private-liability-summary') {
      this.kasko.dispatchEvent('set-state-input', {
        deleted_item_label: getItemName(PL_ITEM, language),
      });
    } else if (item.editScreen === 'buildings-summary') {
      this.kasko.dispatchEvent('set-state-input', {
        deleted_item_label: getItemName(B_ITEM, language),
      });
    }
    this.isOpened = false;
    this.kasko.dispatchEvent('set-state-input', {
      request_item_id: requestItemId,
      is_remove_item_modal: 'opened',
    });
  }

  stateChanged(kasko) {
    this.items = kasko.input.shopping_cart_items;
    this.isOpened = false;
    const background = this.closest('.shopping-basket');
    if (background) {
      background.classList.remove('opened-cart');
    }
  }

  navigateToEnd() {
    this.kasko.dispatchEvent('trigger-requests');
    this.kasko.dispatchEvent('request-payment');
    this.kasko.dispatchEvent('go-to-screen', {
      screen: this.kasko.evaluateJsonLogic(this.end_screen?.schema || this.end_screen),
    });
  }

  getRequestItemId(item) {
    const inputState = this.kasko.getState('input');
    let requestItemId = '';
    if (inputState.item_A_B && !inputState.item_A_B_C) {
      requestItemId = item.id === this.itemA ? this.itemB : this.itemA;
    } else if (inputState.item_A_C && !inputState.item_A_B_C) {
      requestItemId = item.id === this.itemA ? this.itemC : this.itemA;
    } else if (inputState.item_B_C && !inputState.item_A_B_C) {
      requestItemId = item.id === this.itemB ? this.itemC : this.itemB;
    } else if (inputState.item_A_B_C) {
      if (item.id === this.itemA) {
        requestItemId = this.itemBC;
      } else {
        requestItemId = item.id === this.itemB ? this.itemAC : this.itemAB;
      }
    }

    return requestItemId;
  }

  getCostObject(cost) {
    const splittedCost = cost.split(' ');
    const [currency, ...price] = splittedCost;
    return {
      currency,
      price: price.join(' '),
    };
  }
}

export default ShoppingCartComponent;
